import React, { useEffect, Component, useState, useRef } from "react";
import Header from "../../containers/Header";
import Footer from "../../containers/Footer";
import { useHistory, useParams, Link } from "react-router-dom";
import { ApiService } from "../../containers/Services/apiservice";
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const InvestmentSip = () => {
  let history = useHistory();
  const didMountRef = useRef(true);
  const [MutualFundEquityData, setMutualFundEquityData] = useState([]);
  const [MutualFundDebtData, setMutualFundDebtData] = useState([]);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [Message, setMessage] = useState('');
  const [EquityAmt, setEquityAmt] = useState('');
  const [DebtAmt, setDebtAmt] = useState('');
  const [MFArray, setMFArray] = useState([]);
  // const [selectedMF, setselectedMF] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    if (didMountRef.current) {
      mutualfunddataamultifiler();
      localStorage.removeItem("SELMFS");
      // if(localStorage.getItem("SELMFS") && JSON.parse(localStorage.getItem("SELMFS")) != null)
      // {
      // setMFArray(JSON.parse(localStorage.getItem("SELMFS")));
      // }
      // else{
      //   localStorage.setItem("SELMFS", []);
      // }
    }
    didMountRef.current = false;
  });
  const addmutualfundtolist = (mfObj) => {
    let selectedMF = [];
    if (localStorage.getItem("SELMFS") && localStorage.getItem("SELMFS") != null) {
      selectedMF = JSON.parse(localStorage.getItem("SELMFS"));
    }
    if (selectedMF.length > 0 && selectedMF.includes(mfObj.mf_id)) {
      selectedMF.push(selectedMF.splice(selectedMF.indexOf(mfObj.mf_id), 1)[0])
      selectedMF.pop()
    } else {
      selectedMF.push(mfObj.mf_id)
    }
    localStorage.setItem("SELMFS", JSON.stringify(selectedMF));
    setMFArray(JSON.parse(localStorage.getItem("SELMFS")));
  }
  const mutualfunddataamultifiler = () => {
    setSpinnerLoading(true);
    const dataString = {
      type: "investment",
      gs_id: id,
      "investment": 'SIP'
    };
    apiServices.getmutualInvestmentData(dataString).then((res) => {
      if (res.data.status == "success") {
        setMutualFundEquityData(res.data.equity);
        setMutualFundDebtData(res.data.debt);
        setSpinnerLoading(false);
        setMessage(res.data.message)
        setDebtAmt(res.data.debtamt)
        setEquityAmt(res.data.equityamt)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    });
  };
  return (
    <div>
      <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>
          <Watch
            color="#ffffff"
            visible={spinnerLoading}
          />
        </div>
      </div>
      <Header />
      <section className="bg-gray-light section-small">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div class="goalsetting-block mg-b-15"><h6 className="mg-b-0">{Message}</h6></div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="fund34-block">
                <div className="fund34-block-header">
                  <h5>Equity (₹{EquityAmt})</h5>
                </div>
                <div className="fund34-block-body">
                  <div className="fund34-block-list">
                    <ul>
                      {MutualFundEquityData.length > 0
                        ? MutualFundEquityData.map((key) => (
                          <li className={MFArray.includes(key.mf_id) ? 'active' : ''} onClick={(e) => { addmutualfundtolist(key) }}>
                            <Link>
                              {/* to={`/mfsipdetail/${key.mf_id}/${id}`} */}
                              <span className="fund34-check">
                                {
                                  MFArray.includes(key.mf_id) ?
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    : ''
                                }
                              </span>
                              <div className="mg-l-15 fund34-block-details">
                                <h6 className="mg-b-0">{key.plan_name}</h6>
                                <p className="mg-b-0 tx-12">{key.scheme_code}</p>
                              </div>
                            </Link>
                          </li>
                        ))
                        : ""}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">

              <div className="fund34-block">
                <div className="fund34-block-header">
                  <h5>Debt (₹{DebtAmt})</h5>
                </div>
                <div className="fund34-block-body">
                  <div className="fund34-block-list">
                    <ul>
                      {MutualFundDebtData.length > 0
                        ? MutualFundDebtData.map((key) => (
                          <li className={MFArray.includes(key.mf_id) ? 'active' : ''} onClick={(e) => { addmutualfundtolist(key) }}>
                            <Link >
                              {/* to={`/mfsipdetail/${key.mf_id}/${id}`} */}
                              <span className="fund34-check">
                                {
                                  MFArray.includes(key.mf_id) ?
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    : ''
                                }
                              </span>
                              <div className="mg-l-15 fund34-block-details">
                                <h6 className="mg-b-0">{key.plan_name}</h6>
                                <p className="mg-b-0 tx-12">{key.scheme_code}</p>
                              </div>
                            </Link>
                          </li>
                        ))
                        : ""}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      {
        MFArray.length > 0 ?
          <div className="popup-addfundcart">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <h6 className="mg-b-5">Total Fund Selected: {MFArray.length}</h6>
                  <div className="pop-addfundlist">
                    Added To Your Bucket Now You Can Click On Continue
                  </div>
                </div>
                <div className="col-lg-4 tx-right"><div class="theme-button">
                  <Link class="btn" to={`/mfsipdetail/${id}`}>Continue</Link>

                </div></div>
              </div>
            </div>
          </div> : ''
      }
    </div>
  );
};
export default InvestmentSip;
